(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/input/contact-input.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/input/contact-input.js');
"use strict";


const TextInput = svs.ui.reactFormInputs.TextInput;
const CONTACT = svs.ticket_partner.sharedComponents.input.constants.names.CONTACT;
const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.input.constants.TEXTS.CONTACT_PERSON,
  LABEL = _svs$ticket_partner$s.LABEL,
  MAX = _svs$ticket_partner$s.MAX,
  MAX_ERROR = _svs$ticket_partner$s.MAX_ERROR,
  REQUIRED_ERROR = _svs$ticket_partner$s.REQUIRED_ERROR;
const ContactInput = _ref => {
  let handleChange = _ref.handleChange,
    state = _ref.state,
    _ref$stateField = _ref.stateField,
    stateField = _ref$stateField === void 0 ? null : _ref$stateField,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? null : _ref$name,
    _ref$isLessSpace = _ref.isLessSpace,
    isLessSpace = _ref$isLessSpace === void 0 ? false : _ref$isLessSpace;
  return React.createElement(TextInput, {
    disabled: disabled,
    errorMessageMax: MAX_ERROR,
    errorMessageRequired: REQUIRED_ERROR,
    id: stateField || CONTACT,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: LABEL,
    max: MAX,
    name: name || CONTACT,
    onChange: handleChange,
    value: state[stateField || CONTACT] || ''
  });
};
svs.ticket_partner.sharedComponents.input.ContactInput = ContactInput;

 })(window);